import {
  ToolOutlined,
  SwapOutlined,
  InboxOutlined,
  SafetyCertificateOutlined,
  FileDoneOutlined,
  RetweetOutlined,
} from "@ant-design/icons";

export const serviceSteps = [
  {
    title: "Service Order",
    description:
      "Initiate and track service requests with detailed specifications.",
    icon: ToolOutlined,
    bg: "#e6f7ff",
    color: "#1890ff",
  },
  {
    title: "Service Challan",
    description:
      "Record material movement when sending items to the service provider.",
    icon: SwapOutlined,
    bg: "#f6ffed",
    color: "#52c41a",
  },
  {
    title: "Goods Received Note (GRN)",
    description:
      "Track the return of serviced materials, including partial returns if applicable.",
    icon: InboxOutlined,
    bg: "#e6f7ff",
    color: "#1890ff",
  },
  {
    title: "Quality Report",
    description:
      "Inspect returned materials and separate good stock from rejected items.",
    icon: SafetyCertificateOutlined,
    bg: "#f9f0ff",
    color: "#722ed1",
  },
  {
    title: "Service Supplier Invoice",
    description:
      "Record service provider invoices with direct linkage to service orders and GRNs.",
    icon: FileDoneOutlined,
    color: "#fa8c16",
  },
  {
    title: "Credit/Debit Note",
    description:
      "Handle financial adjustments related to service charges, rework, or rejections.",
    icon: RetweetOutlined,
    bg: "#f0f0f0",
    color: "#8c8c8c",
  },
];

export enum serviceFeatureText {
  HERO_TITLE = "Service Management Made Seamless",
  HERO_DESCRIPTION = `Efficiently Manage Service Workflows and Material Movements in One Integrated System Welcome to the Service Management Module of Ease Margin – your smart solution to manage service orders, material dispatch, returns, quality checks, and service invoicing in a fully traceable and streamlined process. `,
  HERO_BUTTON = "Get Started for Free",

  INTRO_TITLE = "🤔 Why Manage Service the Old Way? Go Smart with Ease Margin.",
  INTRO_DESCRIPTION = `Say goodbye to disconnected service tracking and manual document handling. With Ease Margin, your entire service process is linked, transparent, and easy to control. `,

  SERVICE_FLOW_TITLE = "🛠️ End-to-End Service Workflow",
  MULTI_FORMAT_TITLE = "🗂️ Multi-Format Service Documents: Your service documents, your way.",
  DASHBOARD_TITLE = "📈 Real-Time Dashboard: Track Every Service Movement",
  ADVANTAGE_TITLE = "💡 Why Choose Ease Margin for Service Management?",
  DOC_FORMAT = "📝 Generate Documents in Multiple Formats",
  SHARING_STORE = "☁️ Seamless Sharing & Storage",

  PERFECT_FOR_TITLE = "🏢 Perfect For:",
  CTA_TITLE = "🚀 Start Using Smart Service Management Today.",

  CTA_DESCRIPTION = `Upgrade your service process to a fully connected, transparent, and efficient system with Ease Margin.`,
  CTA_BUTTON = "Contact Us for a Free Demo",
}

export const serviceTemplates = [
  {
    icon: "🎨",
    title: "Customizable Templates",
    description:
      "Add your company logo, terms & conditions, and service notes (excluding bank details).",
  },
  {
    icon: "🗃️",
    title: "Smart Document Repository",
    description:
      "Organized, searchable service records with filters by service provider, status, document type, and date.",
  },
];

export const serviceFeaturedCards = [
  {
    icon: "⚙️",
    title: "Additional Smart Features",
    description:
      "Take your purchase management to the next level with these advanced capabilities:",
  },
  {
    icon: "🔗",
    title: "Auto-Linked Service Documents:",
    description:
      "Purchase Orders, GRNs, Invoices, and Debit/Credit Notes are automatically linked for complete traceability.",
  },
  {
    icon: "📦",
    title: "Material Movement Tracking for Services:",
    description:
      "Instantly view what is pending from each supplier, whether partial or complete deliveries.",
  },
  {
    icon: "❌",
    title: "Rejection Management for Returned Materials:",
    description:
      "Easily manage rejected items and ensure they are excluded from stock and invoicing.",
  },
  {
    icon: "🔔",
    title: "Smart Notifications & Reminders:",
    description:
      "Stay informed about pending approvals, delayed deliveries, and upcoming payment deadlines.",
  },
  {
    icon: "📝",
    title: "Approval Workflow for Service Orders:",
    description:
      "Built-in approval stages for purchase requests and orders for tighter control.",
  },
  {
    icon: "📊",
    title: "Service Provider Performance Reports:",
    description:
      "Track supplier reliability, delivery timelines, and quality scores to improve purchasing decisions.",
  },
];

export const serviceDashboardFeatures = [
  "Visualized Service pipelines",
  "Document status widgets",
  "Pending returns and quality check alerts",
  "Supplier-wise summaries",
  "Live notifications for pending service actions",
];

export const serviceAdvantages = [
  "Seamless Service Order to Completion Workflow",
  "Real-Time Material Movement Tracking",
  "Multiple Document Format Support",
  "Linked Service Documents for Full Traceability",
  "Detailed Quality Reports on Returned Materials",
  "Accurate Supplier Invoicing and Financial Records",
  "Customizable, Professional Service Documents",
];

export const serviceTargetAudience = [
  "Trading Companies",
  "Manufacturers",
  "Distributors",
  "SMEs looking to digitize their Service process",
];
